var n,r=((n=function(){return r}).toString=n.toLocaleString=n[Symbol.toPrimitive]=function(){return ""},n.valueOf=function(){return !1},new Proxy(Object.freeze(n),{get:function(n,t){return n.hasOwnProperty(t)?n[t]:r}})),u=function(n){return n===r};

let win = global.window;
let doc = global.document;
let nav = global.navigator;
let document = typeof doc !== "undefined" ? doc : r;
let exists = (variable) => !u(variable);
let navigator = typeof nav !== "undefined" ? nav : r;
let window = typeof win !== "undefined" ? win : r;

export { document, exists, navigator, window };
//# sourceMappingURL=browser-monads-ts.es.js.map
